import { PublicLoadable } from "@utils/loadable";
import LoadableLoading from "@components/Loading/LoadbleLoader";

export default PublicLoadable(() => import("./index"), {
  fallback: <LoadableLoading />,
});
